/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable no-nested-ternary */
/* eslint-disable array-callback-return */

import React, { useState, useEffect } from 'react'
import { useDispatch, connect, useSelector } from 'react-redux'
import { Menu, Badge, Dropdown, Avatar, Comment, notification, Icon } from 'antd'
import { BellOutlined } from '@ant-design/icons'
import Websocket from 'react-websocket'
import { Link, withRouter } from 'react-router-dom'
import { useLazyQuery } from 'react-apollo'
import { TiArrowBack } from 'react-icons/ti'
import gql from 'graphql-tag'
import _ from 'lodash'
import store, { set } from 'store'
import moment from 'moment'
import { REACT_APP_API_URL } from 'apollo/REACT_APP_URL'
import client from 'apollo/config'
import styles from './style.module.scss'
import ProfileMenu from './ProfileMenu'

const { SubMenu, Divider } = Menu

let baseUrl = 'application.cogniable.us'
if (REACT_APP_API_URL.includes('development')) baseUrl = 'development.cogniable.us'
if (REACT_APP_API_URL.includes('quality')) baseUrl = 'quality.cogniable.us'

export const GET_POSITION_MENU = gql`
  query staffPositionMenu($positionId: ID!) {
    staffPositionMenu(staffPositionId: $positionId) {
      staffPosition {
        id
        title
      }
      clinic {
        schoolName
      }
      filteredKeys
    }
  }
`

const compare = (a, b) => {
  if (moment(a.timestamp) < moment(b.timestamp)) {
    return 1
  }
  return -1
}

const MenuTop = props => {
  const [userId, setUserId] = useState(localStorage.getItem('userId'))
  const [selectedKeys, setSelectedKeys] = useState(store.get('app.menu.selectedKeys') || [])
  const [notificationList, setNotificationList] = useState([])
  const [unreadNotifications, setUnreadNotifications] = useState(0)
  const [selectedNotifcation, setSelectedNotifcation] = useState(null)
  const [staffMenuList, setStaffMenuList] = useState([])

  const dispatch = useDispatch()
  const user = useSelector(state => state.user)
  const position = user?.staffObject?.position

  const [getStaffPositionMenus, { data: staffMenus }] = useLazyQuery(GET_POSITION_MENU, {
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    if (position !== null && position !== undefined) {
      getStaffPositionMenus({ variables: { positionId: position?.id } })
    }
  }, [user, position])

  useEffect(() => {
    if (staffMenus?.staffPositionMenu?.length) {
      setStaffMenuList(staffMenus?.staffPositionMenu[0]?.filteredKeys)
    }
  }, [staffMenus])

  useEffect(() => {
    setSelectedKeysFun(props)
    if (userId) {
      fetchNotification(userId)
    }
    setTimeout(function() {
      setUserId(localStorage.getItem('userId'))
    }, 3000)
    setTimeout(function() {
      setUserId(localStorage.getItem('userId'))
    }, 5000)
  }, [])

  useEffect(() => {
    if (userId) {
      fetchNotification(userId)
    }
  }, [selectedNotifcation, userId])

  const fetchNotification = id => {
    client
      .query({
        query: gql`
          query {
            notification(recipient: ${id} last: 25) {
              edges {
                node {
                  id
                  title
                  description
                  timestamp
                  read
                  recipient {
                    id
                    username
                  }
                  actorObjectId
                  notifyType
                  modelId
                }
              }
            }
          }
        `,
        fetchPolicy: 'network-only',
      })
      .then(res => {
        let notiList = []
        let tempCount = 0
        res.data.notification.edges.map(item => {
          notiList.push(item.node)
          tempCount += item.node.read === false ? 1 : 0
        })
        notiList = notiList.sort(compare)
        setNotificationList(notiList)
        setUnreadNotifications(tempCount)
      })
      .catch(err =>
        notification.error({
          message: 'Something went wrong',
          description: 'Unable to fetch recent notifications',
        }),
      )
  }

  const setSelectedKeysFun = tt => {
    const { menuData } = props
    const flattenItems = (items, key) =>
      items.reduce((flattenedItems, item) => {
        flattenedItems.push(item)
        if (Array.isArray(item[key])) {
          return flattenedItems.concat(flattenItems(item[key], key))
        }
        return flattenedItems
      }, [])
    const selectedItem = _.find(flattenItems(menuData, 'children'), ['url', tt.location.pathname])

    setSelectedKeys(selectedItem ? [selectedItem.key] : [])
  }

  const handleClick = e => {
    const { isSettingsOpen } = props
    store.set('app.menu.selectedKeys', [e.key])
    if (e.key === 'settings') {
      dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'isSettingsOpen',
          value: !isSettingsOpen,
        },
      })
      return
    }

    setSelectedKeys([e.key])
  }

  const generateMenuItems = () => {
    const {
      menuData = [],
      school: { mlGraph, mlRecommendation, mlSimilarity },
    } = props

    const generateItem = (item, isSubMenu) => {
      const { key, title, url, icon, pro, disabled } = item

      if (item.divider) {
        return <Divider key={Math.random()} />
      }
      if (item.url) {
        return (
          <Menu.Item
            key={key}
            title={title}
            disabled={
              staffMenuList.includes(key) || key === 'MLRecommendationModel'
                ? !mlRecommendation
                : key === 'MLGraphModel'
                ? !mlGraph
                : key === 'MLAssessments'
                ? !mlSimilarity
                : false
            }
            style={{ padding: '0px 12px', textAlign: 'left', minWidth: 80 }}
          >
            {item.target ? (
              <a href={url} target={item.target} rel="noopener noreferrer">
                {icon && (
                  <>
                    <span
                      style={{ margin: 0 }}
                      title={title}
                      className={`${icon} ${styles.icon}`}
                    />
                    <p style={{ marginTop: -13, lineHeight: '10px', fontSize: 10 }}>{title}</p>
                  </>
                )}
                {isSubMenu && (
                  <>
                    <span className={styles.title}>
                      {/* <Trans>{title}</Trans> */}
                      {title}
                    </span>
                  </>
                )}
                {pro && <span className="badge badge-primary ml-2">PRO</span>}
              </a>
            ) : (
              <Link to={url}>
                {icon && (
                  <div style={{ margin: 0, textAlign: 'center' }}>
                    <span
                      style={{ margin: 0 }}
                      title={title}
                      className={`${icon} ${styles.icon}`}
                    />
                    <p style={{ marginTop: -13, lineHeight: '10px', fontSize: 10 }}>{title}</p>
                  </div>
                )}
                {isSubMenu && (
                  <>
                    <span className={styles.title}>{title}</span>
                  </>
                )}
                {pro && <span className="badge badge-primary ml-2">PRO</span>}
              </Link>
            )}
          </Menu.Item>
        )
      }

      return (
        <Menu.Item key={key} title={title} disabled={disabled}>
          {icon && (
            <>
              <span style={{ margin: 0 }} title={title} className={`${icon} ${styles.icon}`} />
              <p style={{ marginTop: -13, lineHeight: '10px', fontSize: 10 }}>{title}</p>
            </>
          )}
          <>
            <span className={styles.title}>{/* <Trans>{title}</Trans> */}</span>
            {title}
          </>
          {pro && <span className="badge badge-primary ml-2">PRO</span>}
        </Menu.Item>
      )
    }

    const generateSubmenu = items =>
      items.map(menuItem => {
        if (menuItem.children) {
          const subMenuTitle = (
            <span className={styles.menu} key={menuItem.key}>
              <span className={styles.title}>{menuItem.title}</span>
              {menuItem.icon && (
                <span style={{ margin: 0 }} className={`${menuItem.icon} ${styles.icon}`} />
              )}
            </span>
          )
          return (
            <SubMenu style={{ minWidth: 180 }} title={subMenuTitle} key={menuItem.key}>
              {generateSubmenu(menuItem.children)}
            </SubMenu>
          )
        }
        return generateItem(menuItem, true)
      })

    return menuData.map(menuItem => {
      if (menuItem.children) {
        const subMenuTitle = (
          <div
            className={styles.menu}
            key={menuItem.key}
            style={{ marginBottom: '11px', display: 'block' }}
          >
            {menuItem.icon && (
              <>
                <span
                  style={{ margin: 0 }}
                  title={menuItem.title}
                  className={`${menuItem.icon} ${styles.icon}`}
                />
                <p style={{ fontSize: 10, lineHeight: '13px', marginTop: -14, marginBottom: 3 }}>
                  {menuItem.title}
                </p>
              </>
            )}
          </div>
        )
        return (
          <SubMenu
            title={subMenuTitle}
            key={menuItem.key}
            style={{ padding: '0px 0px', textAlign: 'center', minWidth: 80 }}
          >
            {generateSubmenu(menuItem.children)}
          </SubMenu>
        )
      }
      return generateItem(menuItem, false)
    })
  }

  const handleReadNotification = item => {
    if (item && item.id) {
      client
        .mutate({
          mutation: gql`
        mutation {
          markAsRead(input: { pk: "${item.id}"  }) {
            details {
              id
              title
            }
          }
        }
        `,
        })
        .then(res => {
          fetchNotification(userId)
        })
        .catch(err => {
          notification.error({
            message: 'Somthing went wrong',
            description: 'Unable to mark notification as read',
          })
        })
      setSelectedNotifcation(item)
      // updatenotificationRedirectUrl(item.title)
    }
  }

  const handleData = data => {
    data = JSON.parse(data)
    // console.log("New Notification data =======> ", data)
    const tempNotification = notificationList
    if (data) {
      tempNotification.unshift(data)
      setNotificationList(tempNotification)
      setUnreadNotifications(unreadNotifications + 1)
    }
  }

  const handleReminderData = data => {
    data = JSON.parse(data)
    if (data) {
      notification.info({
        message: data.title,
        description: (
          <>
            <p>{data.description}</p>{' '}
            <p>
              {moment(moment.utc(data.time, 'HH:mm:ss'))
                .local()
                .format('HH:mm A')}
            </p>{' '}
          </>
        ),
        duration: 0,
        icon: <Icon type="clock-circle" />,
      })
    }
  }

  const {
    isLightTheme,
    history: { goBack },
  } = props

  const menu = (
    <Menu
      className={`${styles.menu}${styles.temp} ${styles.scroll}`}
      style={{ height: `${notificationList.length > 0 ? 500 : 50}px` }}
    >
      {notificationList.length > 0 ? (
        notificationList.map((item, itemIdx) => {
          let url = '#'
          switch (item.title) {
            case 'New Task':
              // setnotificationRedirectUrl('#/viewTask')
              url = '#/viewTask'
              break
            case 'Appointment':
              // setnotificationRedirectUrl('#/appointmentData')
              url = '#/appointmentData'
              break
            case 'Meal Data':
              // setnotificationRedirectUrl('#/LearnerMeal')
              url = '#/LearnerMeal'
              break
            case 'Medical Data':
              // setnotificationRedirectUrl('#/LearnerMedical')
              url = '#/LearnerMedical'
              break
            case 'Toilet Data':
              // setnotificationRedirectUrl('#/LearnerToilet')
              url = '#/LearnerToilet'
              break
            case 'Behavior Data':
              // setnotificationRedirectUrl('#/LearnerBehavior')
              url = '#/LearnerBehavior'
              break
            case 'Session':
              // setnotificationRedirectUrl('#/LearnerSessions')
              url = '#/LearnerSessions'
              break
            default:
              url = '#'
              break
          }
          return (
            <Menu.Item
              key={Math.random()}
              style={{
                textOverflow: 'inherit',
                wordWrap: 'break-word',
                whiteSpace: 'normal',
                padding: 0,
                margin: 0,
                backgroundColor: `${item.read ? '#ecf2f8' : 'white'}`,
                borderTop: '1px solid #969698',
              }}
              onClick={() => handleReadNotification(item)}
            >
              <a href={url}>
                <Comment
                  author={<a>{item.title}</a>}
                  content={
                    <p>
                      {item.description.length > 80 ? (
                        <>{item.description.slice(0, 80)}...</>
                      ) : (
                        <>{item.description}</>
                      )}
                    </p>
                  }
                  datetime={<span>{moment(item.timestamp).fromNow()}</span>}
                />
              </a>
            </Menu.Item>
          )
        })
      ) : (
        <div style={{ textAlign: 'center', margin: '35px autp' }}>No Notification</div>
      )}
    </Menu>
  )

  return (
    <div>
      <div className={styles.logo}>
        <div
          className={styles.logoContainer}
          style={{ backgroundColor: 'white', borderBottom: '1px solid #f2f2f2' }}
        >
          <img
            src="resources/images/HeaderLogo.png"
            alt="CogniAble Logo"
            style={{ marginLeft: '0px' }}
          />
        </div>
      </div>

      <Menu
        theme={isLightTheme ? 'light' : 'dark'}
        onClick={handleClick}
        selectedKeys={selectedKeys}
        mode="horizontal"
      >
        {generateMenuItems()}

        <Menu.Item
          style={{ padding: '8px 14px', textAlign: 'center', float: 'right', height: '58px' }}
        >
          <ProfileMenu />
        </Menu.Item>
        <Menu.Item
          style={{ padding: '2px 14px', textAlign: 'center', float: 'right', height: '58px' }}
          onClick={goBack}
        >
          <a>
            <TiArrowBack style={{ fontSize: 20 }} />
            <p style={{ fontSize: 10, lineHeight: '13px', marginTop: -14, marginBottom: 3 }}>
              Back
            </p>
          </a>
        </Menu.Item>
        <Menu.Item
          style={{ padding: '2px 14px', textAlign: 'center', float: 'right', height: '58px' }}
        >
          <Dropdown
            className={`${styles.temp}`}
            style={{ width: 'fit-content' }}
            overlay={menu}
            trigger={['click']}
            placement="topRight"
          >
            <a>
              <Badge count={unreadNotifications}>
                <BellOutlined style={{ fontSize: 18, paddingLeft: 8 }} />
              </Badge>
              <p style={{ fontSize: 10, lineHeight: '13px', marginTop: -14, marginBottom: 3 }}>
                Notification
              </p>
            </a>
          </Dropdown>
        </Menu.Item>
      </Menu>
      <Websocket
        key={userId}
        url={`wss://${baseUrl}/apis/ws/notification/${user?.id}`}
        onMessage={handleData}
      />
      <Websocket
        key={`reminder${userId}`}
        url={`wss://${baseUrl}/apis/ws/reminder/${user?.id}`}
        onMessage={handleReminderData}
      />
    </div>
  )
}

const mapStateToProps = ({ menu, settings, school, staff, user }) => ({
  menuData: menu.menuTopData,
  isLightTheme: settings.isLightTheme,
  isSettingsOpen: settings.isSettingsOpen,
  school,
  staff,
  user,
})

export default withRouter(connect(mapStateToProps)(MenuTop))
